import { RectNode, RectNodeModel, h } from '@logicflow/core';
import { drawLabel } from './textUtils';
import { applySimStatusStyle } from './simStatus';
import { getThemeStyle } from '../theme';

const CUT = 12;

class BKMView extends RectNode {
  getShape() {
    const { model } = this.props;
    const { x, y, width, height } = model;
    const style = model.getNodeStyle();
    const label = model.properties?.name || model.text?.value || '';
    const textFill = (model.graphModel?.__epxDmnTheme?.text?.fill) || '#212121';

    const l = x - width / 2;
    const r = x + width / 2;
    const t = y - height / 2;
    const b = y + height / 2;

    // Pentagon-like: top-left and bottom-right corners chamfered
    const d = `
      M ${l + CUT} ${t}
      L ${r} ${t}
      L ${r} ${b - CUT}
      L ${r - CUT} ${b}
      L ${l} ${b}
      L ${l} ${t + CUT}
      Z
    `;

    return h('g', {}, [
      h('path', { d, ...style }),
      drawLabel(h, label, x, y, width - 16, { fill: textFill }),
    ]);
  }

  getText() { return ''; }
}

class BKMModel extends RectNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.width = 135;
    this.height = 46;
    this.text = { ...this.text, editable: true, draggable: false, value: this.text?.value || '' };
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'businessKnowledgeModel');
    style.stroke = t.stroke || '#722ed1';
    style.strokeWidth = t.strokeWidth || 2;
    style.fill = t.fill || '#f9f0ff';
    return applySimStatusStyle(style, this.properties);
  }
}

export const BusinessKnowledgeModel = {
  type: 'dmn:BusinessKnowledgeModel',
  view: BKMView,
  model: BKMModel,
};
